import { useQuery } from "@tanstack/react-query"
import { useApi } from "../../../../hooks/useApi"
import { IAccountBookPairs } from "../../types"

const useRiskKeyMetricsQuery = ({
  accountBookPairs,
  enabled,
}: {
  accountBookPairs: IAccountBookPairs
  enabled: boolean
}) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["riskExposures", accountBookPairs],
    () => scientApi.trading.getRiskKeyMetrics({ accountBookPairs }),
    {
      staleTime: Infinity,
      enabled,
    },
  )

  return {
    riskKeyMetrics: data,
    isLoading,
    error,
  }
}

export default useRiskKeyMetricsQuery
